import { useEffect } from "react";
import { LoadingSpinner } from "../../components/ui/LoadingSpinner";

export function AuthCallback() {
  useEffect(() => {
    // Forward the OAuth params (code, state) to the backend API
    const params = window.location.search;
    if (params) {
      // Use window.location.href to follow the backend's 302 redirect
      window.location.href = `/api/auth/callback${params}`;
    } else {
      // If no params, redirect to home with error
      window.location.href = '/?error=missing_params';
    }
  }, []);

  return (
    <div className="min-h-screen bg-background flex items-center justify-center">
      <div className="text-center">
        <LoadingSpinner size="lg" label="Finalizing authentication..." className="mb-4" />
        <p className="text-muted-foreground">Finalizing authentication...</p>
      </div>
    </div>
  );
}